import React from "react";
import moment from "moment-timezone";
import keyBy from "lodash/keyBy";

import MarqueeListEntry from "./marquee-list-entry.jsx";
import DateButtons from "./date-buttons.jsx";

class MarqueeFilmTicketsWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      eventsByDate: {},
      selectedDate: null,
      dates: []
    };
  }

  componentWillMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(props) {
    if (props.film.events.length) {
      const { events } = props.film,
        eventsByDate = events.reduce((d, e) => {
          const key = moment(e.start_time)
            .startOf("day")
            .format();
          const venueName = e.venue ? e.venue.name : "Unknown Venue";
          if (!d[key]) {
            d[key] = {};
          }
          if (!d[key][venueName]) {
            d[key][venueName] = [];
          }
          d[key][venueName].push({
            id: e.id,
            start_time: e.start_time,
            start_time_label: moment(e.start_time)
              .format("h:mma")
              .slice(0, -1)
          });
          return d;
        }, {}),
        dates = Object.keys(eventsByDate).sort();

      let { selectedDate } = this.state;

      if (!selectedDate) {
        const today = moment()
          .startOf("day")
          .format();
        if (dates.some(d => d === today)) {
          selectedDate = today;
        } else {
          selectedDate = dates[0];
        }
      }

      this.setState({
        selectedDate: moment(selectedDate),
        eventsByDate,
        dates
      });
    }
  }

  render() {
    const { film } = this.props,
      { selectedDate, dates, eventsByDate } = this.state;

    return (
      <div>
        <DateButtons
          selectedDate={selectedDate}
          dates={dates}
          onDateSelected={selectedDate => this.setState({ selectedDate })}
          forceSmall={true}
          inline={true}
          rawDate={true}
        />
        <MarqueeListEntry
          inlineOnFilm={true}
          film={film}
          showings={eventsByDate[selectedDate.format()]}
        />
      </div>
    );
  }
}

export default MarqueeFilmTicketsWidget;



// WEBPACK FOOTER //
// ./src/app/components/partials/marquee/marquee-film-tickets-widget.jsx